import React from 'react'
import { Box } from '@material-ui/core'

type Props = {
  children: NonNullable<React.ReactNode>
}

export function DefaultLayout({ children }: Props): React.ReactElement {
  return (
    <Box flexGrow={1} padding={2}>
      {children}
    </Box>
  )
}
